import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import RoastLevelHorizontal from "~/components/RoastLevelHorizontal.jsx";
import ActiveMarkerHorizontal from "~/components/ActiveMarkerHorizontal.jsx";

const getPositions = (width) => {
  const isMobile = width <= 768;
  return isMobile
    ? [
        { label: "bright-light", x: "5%" },
        { label: "light", x: "23%" },
        { label: "medium", x: "41%" },
        { label: "full-medium", x: "59%" },
        { label: "dark", x: "77%" },
        { label: "beyond-dark", x: "95%" },
      ]
    : [
        { label: "bright-light", x: "2.5%" },
        { label: "light", x: "21.5%" },
        { label: "medium", x: "40.5%" },
        { label: "full-medium", x: "59.5%" },
        { label: "dark", x: "78.5%" },
        { label: "beyond-dark", x: "97.5%" },
      ];
};

const RoastLevelSpectrums = ({ collections, activeCollectionHandler, activeCollection }) => {
  const [positions, setPositions] = useState(getPositions(window.innerWidth));

  let activeBgHexColor = "";
  let activeTextHexColor = "";

  switch (activeCollection.collectionHandle) {
    case "bright-light":
      activeBgHexColor = "#ffd98a";
      activeTextHexColor = "#4d4e53";
      break;
    case "light":
      activeBgHexColor = "#f8be00";
      activeTextHexColor = "#4d4e53";
      break;
    case "medium":
      activeBgHexColor = "#d48232";
      activeTextHexColor = "#4d4e53";
      break;
    case "full-medium":
      activeBgHexColor = "#bc4700";
      activeTextHexColor = "#fff";
      break;
    case "dark":
      activeBgHexColor = "#8c88a3";
      activeTextHexColor = "#fff";
      break;
    case "beyond-dark":
      activeBgHexColor = "#003b4d";
      activeTextHexColor = "#fff";
      break;
    default:
      activeBgHexColor = "#fff";
      activeTextHexColor = "#4d4e53";
  }

  useEffect(() => {
    const handleResize = () => {
      setPositions(getPositions(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {collections.length > 0 && (
        <>
          <div
            className="mt-8 md:mt-16 mb-4 md:mb-12 w-full grid rounded-md relative"
            style={{
              background:
                "linear-gradient(to right, #ffd98a 0%, #f1aa1e 20%, #d48232 41%, #bc4700 58%, #8c88a3 82%, #003b4d 100%)",
              gridTemplateColumns: `repeat(${collections.length}, 1fr)`,
            }}>
            <motion.div
              className="absolute left-1/2 -translate-x-1/2 -top-11 md:-top-14 block w-max text-center font-semibold px-2 py-1 rounded border border-white uppercase text-[9px] md:text-[12px]"
              style={{
                backgroundColor: activeBgHexColor,
                color: activeTextHexColor,
                borderColor: activeBgHexColor,
              }}
              animate={{
                left: positions.find(
                  (position) => position.label === activeCollection.collectionHandle
                ).x,
              }}
              transition={{ type: "spring", stiffness: 50, damping: 20 }}>
              {
                positions.find((position) => position.label === activeCollection.collectionHandle)
                  .label
              }
            </motion.div>

            <div className="absolute top-0 left-0 w-full h-full shadow-xl">
              {positions.map((position) => (
                <div
                  key={position.label}
                  className="absolute top-1/2 left-[2.5%] -translate-x-1/2 -translate-y-1/2 inline-flex w-[16px] h-[16px] md:w-[20px] md:h-[20px] rounded-full border-2 border-white"
                  style={{ left: position.x }}></div>
              ))}
            </div>

            {collections.map((collection) => (
              <RoastLevelHorizontal
                key={collection.collectionHandle}
                roastLevel={collection.collectionHandle}
                activeCollectionHandler={activeCollectionHandler}
                activeCollection={activeCollection}
              />
            ))}

            <motion.div
              className="absolute left-1/2 -translate-x-1/2 -top-11 md:top-0 block w-max text-center font-semibold px-2 py-1 rounded border border-none uppercase text-[9px] md:text-[12px]"
              animate={{
                left: positions.find(
                  (position) => position.label === activeCollection.collectionHandle
                ).x,
              }}
              transition={{ type: "spring", stiffness: 50, damping: 20 }}>
              <ActiveMarkerHorizontal />
            </motion.div>
          </div>
        </>
      )}
    </>
  );
};

export default RoastLevelSpectrums;
